import Vue from 'vue'

export default {

  state: Vue.observable({
    clients: [],
  }),
  
  setClients(clients) {
    this.state.clients = clients
  },

  updateClient(newclient) {
    this.state.clients = this.state.clients.map(client => {
      return client.id == newclient.id ? newclient : client
    })
  },
}
